<script setup lang="ts">
import type { Video } from "~/types/media"

const {
  transcription,
  close,
  isDark = true,
} = defineProps<{
  transcription: Video["transcription"]
  close: () => void
  isDark?: boolean
}>()
</script>

<template>
  <div
    id="transcription"
    class="flex max-h-[60vh] flex-col items-start justify-start gap-4 rounded-lg border-2 p-6 font-national2 @xl:w-1/3"
    :class="{
      'border-white/40': isDark,
    }"
  >
    <div class="flex w-full items-start justify-between gap-4">
      <span class="text-2xl font-extrabold">Transkripsjon</span>
      <UButton
        aria-label="lukk transkripsjon"
        aria-controls="transcription"
        variant="quite"
        :theme="isDark ? 'white' : 'black'"
        @click="close"
      >
        <template #prepend>
          <UIcon name="close" />
        </template>
      </UButton>
    </div>

    <p
      v-if="transcription.html"
      class="flex-wrap overflow-scroll pr-6 text-xl leading-10"
      v-html="transcription.html"
    />
    <p v-else class="wrap">
      Vi fant dessverre ingen transkripsjon, <br />
      <UContactCustomerService />
    </p>
  </div>
</template>
